/* eslint-disable */

// import external dependencies
import 'jquery';
import AOS from 'aos';

// Import everything from autoload
import './autoload/_bootstrap.js'; import './autoload/dropdown.js'
import './autoload/dropdown'

// import local dependencies
import Router from './util/Router';
import common from './routes/common';
import home from './routes/home';
import templateOurGroup from './routes/templateOurGroup';
import templateProduct from './routes/templateProduct';
import templateOurTeam from './routes/templateOurTeam';
import templateArticles from './routes/templateArticles';
import templateJobs from './routes/templateJobs';
import templateWorkingAtAlterpharma from './routes/templateWorkingAtAlterpharma';
import templateOurCampaign from './routes/templateOurCampaign';

AOS.init();

/** Populate Router instance with DOM routes */
const routes = new Router({
  // All pages
  common,
  // Home page
  home,

  templateOurGroup,

  templateProduct,

  templateOurTeam,

  templateArticles,

  templateJobs,

  templateWorkingAtAlterpharma,

  templateOurCampaign

});

// Load Events
jQuery(document).ready(() => routes.loadEvents());
